import { render, staticRenderFns } from "./TrainingRecordExpiryNotes.vue?vue&type=template&id=dc890b84&scoped=true&"
import script from "./TrainingRecordExpiryNotes.vue?vue&type=script&lang=js&"
export * from "./TrainingRecordExpiryNotes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc890b84",
  null
  
)

export default component.exports